"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Notifications;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends3 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _ActionTypes = _interopRequireDefault(require("../actions/ActionTypes"));

var DEFAULT_STATE = {};

function Notifications() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _ActionTypes.default.ADD_NOTIFICATION:
      return (0, _extends3.default)({}, state, (0, _defineProperty2.default)({}, action.payload.id, action.payload));

    case _ActionTypes.default.REMOVE_NOTIFICATION:
      {
        if (state[action.payload.id] == null) return state;
        var nextState = (0, _extends3.default)({}, state);
        delete nextState[action.payload.id];
        return nextState;
      }

    default:
      return state;
  }
}

module.exports = exports.default;